import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3;

import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { border, spacing, zIndex, color, themeMode, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var TRANSITION_DURATION = 300;

var getDrawerPosition = function getDrawerPosition(side) {
  if (side === void 0) {
    side = "bottom";
  }

  var horizontalSizes = css(["width:80vw;height:100%;"]);
  var verticalSizes = css(["max-height:80vh;width:100%;max-width:100%;"]);
  return {
    top: css(["top:0;bottom:auto;left:0;", ";"], verticalSizes),
    bottom: css(["top:auto;bottom:0;left:0;", ";"], verticalSizes),
    left: css(["top:0;left:0;", ";"], horizontalSizes),
    right: css(["top:0;right:0;", ";"], horizontalSizes)
  }[side];
};

var Header = styled(Box).withConfig({
  componentId: "sc-1ujbs4n-0"
})(["flex:0 0 auto;border-bottom:", ";padding:", " ", ";", ""], border("base"), spacing("lg"), spacing("xl"), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint("md")(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n            padding: ", " ", ";\n        "])), spacing("sm"), spacing("md"));
});
var Footer = styled(Box).withConfig({
  componentId: "sc-1ujbs4n-1"
})(["flex:0 0 auto;margin-top:auto;border-top:", ";padding:", " ", ";", ""], border("base"), spacing("lg"), spacing("xl"), function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint("md")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n            padding: ", " ", ";\n        "])), spacing("sm"), spacing("md"));
});
var Content = styled(Box).withConfig({
  componentId: "sc-1ujbs4n-2"
})(["flex:1 1 auto;overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;padding:", " ", ";", " ", ";"], spacing("lg"), spacing("xl"), function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint("md")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n            padding: ", " ", ";\n        "])), spacing("sm"), spacing("md"));
}, space);
var Drawer = styled(Box).withConfig({
  componentId: "sc-1ujbs4n-3"
})(["z-index:", ";position:fixed;overflow:hidden;pointer-events:auto;display:flex;flex-direction:column;max-width:100%;max-height:100%;", ";background:", ";color:", ";"], zIndex("modal"), function (_ref4) {
  var side = _ref4.side,
      isFull = _ref4.isFull;
  return isFull ? css(["top:0;right:0;bottom:0;left:0;width:100%;height:100%;"]) : getDrawerPosition(side);
}, color("surface"), themeMode({
  light: palette("neutral.900"),
  dark: palette("neutral.0")
}));
export { Content, Drawer, Footer, Header, TRANSITION_DURATION, getDrawerPosition };